import React, { FC, ReactNode } from "react";
const Visible = (props) => {
  const { children, is } = props;

  if (is) return <>{children}</>;
  return null;
};

export default Visible;
